module.exports = __webpack_public_path__ + "img/photoAlbum4.e2377e10.jpg";